const clinicType = 'physio';
const isProd = process.env.REACT_APP_USER_API_URL.includes('prod');

const config = {
    clinicType,
    isProd,
    mixpanelToken: isProd
        ? '189e32a152f429590258281c65ec1492' // physio prod token
        : '3670bd50f368dec66e70e31dd0090f8e', // physio dev/staging token

    loginBanner: require('./assets/banners/loginPageBannerPhysio.png'),

    cetraBlueLogo: require('./assets/logos/cetra_blue_physio.png'),

    cetraMobileLogo: require('./assets/logos/cetra_marque.png'),

    gtagId: process.env.REACT_APP_GTAG_ID || '',

    accountTypes: [
        {
            type: 'Free',
            title: 'Get started for free',
            description: 'Jump into Cetra with full access to our content and features. No card details. No limits. ',
        },
        {
            type: 'Professional',
            title: 'Unlock pro',
            description:
                'Get the most out of Cetra for just £9.99 per month. Enjoy unlimited digital sharing and printing, plus your own workspace to save, organise, and reuse customised handouts and diagrams.',
        },
        {
            type: 'Clinic',
            title: 'Power your whole clinic',
            description:
                'Invite team members onto Cetra at no extra cost. You’ll get everything in Pro, plus shared clinic access, bundled handouts, clinic branding, and powerful tools designed for growing teams.',
        },
    ],

    feedbackText:
        'We highly appreciate detailed information, as it plays a crucial role in fulfilling our mission of offering comprehensive medical knowledge.',

    landingPageUrl: 'https://www.cetrahealth.com',

    surveyUrl: 'https://form.jotform.com/Cetra_hello/cetra-health-feedback?_kx=Cp7DmMHPcQJ9CvW4TnAWkQ.USbu7j',

    tsCsUrl: 'https://www.cetrahealth.com/legal/terms-of-service',

    upgradeImages: {
        paywall: {
            clinic: require('./assets/banners/ctaUpgradeClinicPaywallPhysio.png'),
            professional: require('./assets/banners/ctaUpgradeProfessionalPaywallPhysio.png'),
        },
        settings: {
            clinic: {
                desktop: require('./assets/banners/ctaUpgradeClinicPhysio.png'),
                mobile: require('./assets/banners/ctaUpgradeClinicMobilePhysio.png'),
            },
            professional: {
                desktop: require('./assets/banners/ctaUpgradeProfessionalPhysio.png'),
                mobile: require('./assets/banners/ctaUpgradeProfessionalMobilePhysio.png'),
            },
            trial: {
                desktop: require('./assets/banners/ctaUpgradeTrialPhysio.png'),
                mobile: require('./assets/banners/ctaUpgradeTrialMobilePhysio.png'),
            },
        },
    },

    practiceOrClinicText: 'clinic',
    // annualDiscountText: 'Save 5% with annual plans',
};

export const getCTAUpgradeImageUrl = (type) => {
    return config.upgradeImages.paywall[type];
};

export const getCTAUpgradeSettingsImageUrl = (planType, isMobile = false) => {
    const viewPort = isMobile ? 'mobile' : 'desktop';
    return config.upgradeImages.settings[planType][viewPort];
};

export const cetraBlueLogo = config.cetraBlueLogo;
export const cetraMobileLogo = config.cetraMobileLogo;
export const feedbackMessage = config.feedbackText;
export const landingPageUrl = config.landingPageUrl;
export const surveyUrl = config.surveyUrl;
export const tsCsUrl = config.tsCsUrl;
export const practiceOrClinicText = config.practiceOrClinicText;

export default config;
